const EditarMobileIcon = ({ color }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6007 4.05522e-06C10.8849 0.00160133 10.1656 0.293286 9.56765 0.871955L0.729061 9.69754C0.598163 9.82773 0.516445 9.99914 0.497782 10.1826L0.00397128 15.1227C-0.0455868 15.6235 0.375661 16.0448 0.877517 15.9962L5.83907 15.5157C6.02402 15.4978 6.19695 15.4162 6.32819 15.2849L15.1668 6.46243C16.2777 5.35347 16.2778 3.53298 15.1668 2.424L13.6135 0.871955C13.0287 0.288262 12.3165 -0.00124981 11.6007 4.05522e-06ZM11.6351 1.59572C11.9449 1.61042 12.2396 1.76079 12.4821 2.00284L14.0354 3.55332C14.5391 4.0561 14.5391 4.83031 14.0354 5.3331L12.8462 6.52014L9.50983 3.18988L10.699 2.00284C11.0005 1.70191 11.3253 1.581 11.6351 1.59572ZM1.98234 11.4165L4.60298 14.0308L1.6948 14.3131L1.98234 11.4165Z"
        fill={color}
      />
    </svg>
  );
};

export default EditarMobileIcon;
